import { useState } from "react";
import "../../../css/RefundModal.css";

/**
 * 환불 뱃지 아코디언 컴포넌트
 * @param {Object} props
 * @param {number} props.refundedAmount - 환불된 금액
 * @param {number} props.remainingAmount - 잔액
 * @param {string} props.refundDate - 환불 날짜
 */
function RefundBadge({ refundedAmount, remainingAmount, refundDate }) {
  const [expanded, setExpanded] = useState(false);

  const isPartial = (remainingAmount ?? 0) > 0;
  const label = isPartial ? "부분환불" : "전체환불";
  const badgeClass = isPartial ? "badge-부분환불" : "badge-환불";

  const handleClick = (e) => {
    e.stopPropagation();
    setExpanded((prev) => !prev);
  };

  return (
    <span
      className={`badge ${badgeClass} refund-badge${expanded ? " expanded" : ""}`}
      onClick={handleClick}
    >
      {label}(-{(refundedAmount || 0).toLocaleString()}원)
      {expanded && (
        <span className="refund-badge-detail">
          <br />
          잔액({(remainingAmount || 0).toLocaleString()}원)
          <br />
          {refundDate || ""}
        </span>
      )}
    </span>
  );
}

export default RefundBadge;
